/**
 * Converts a string to lowercase while preserving any uppercase abbreviations.
 *
 * Example:
 * "Hello WORLD from NASA" -> "hello WORLD from NASA"
 */

export const toLowerCaseWithPreservedAbbreviations = (text: string | null | undefined): string => {
    if (!text) return '';

    const abbreviationRegex = /[A-Z]{2,}/g;
    const matches: Array<{ value: string; index: number }> = [];

    let match: RegExpExecArray | null;

    // Find all matches with their indices
    while ((match = abbreviationRegex.exec(text)) !== null) {
        matches.push({
            value: match[0],
            index: match.index,
        });
    }

    let newText = text.toLowerCase().split('');

    // Replace abbreviations from end to start to avoid index shifting
    matches.reverse().forEach(({ value, index }) => {
        newText.splice(index, value.length, ...value.split(''));
    });

    return newText.join('');
};
